import { ApostleClass, ApostleClassType } from '@apeiron/apostle'
import { NextImage } from '@apeiron/temp'
import { Box, styled, Typography } from '@mui/material'
import CustomDropdown from '@src/components/apostles/bounty/CustomDropdown'
import { ApostleClassChipGroupView } from '@src/components/apostles/list/filter/ApostleClassFilter'
import useFetchApostleFilterJson from '@src/hooks/json/useFetchApostleFilterJson'
import * as R from 'ramda'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const Container = styled(Box)`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  background-color: #dfdfdf;
  padding: 8px;
  max-width: 320px;
`

const ApostleIcon = styled(NextImage)`
  height: 24px;
  width: 24px;
  aspect-ratio: 1;
`

const DisplayName = styled(Typography)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-transform: capitalize;
`

const UnselectedText = styled(Typography)`
  margin: 0 8px;
`

const ClassContainer = styled(Box)`
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
`

const ApostleClassSelector = ({ selectedValue, onChange }: Props) => {
  const { data } = useFetchApostleFilterJson()

  const { t } = useTranslation()

  const [classes, setClasses] = useState<ApostleClass[]>([])

  useEffect(() => {
    if (R.isNotNil(data)) {
      setClasses(data.class.values)
    }
  }, [data])

  if (R.isNil(classes)) {
    return <></>
  }

  const selectedClass = classes.find(c => c.type === selectedValue)

  return (
    <>
      <CustomDropdown
        renderDropdownContent={({ closeDropdown }) => {
          return (
            <Container>
              <ApostleClassChipGroupView
                options={classes}
                selectedValue={selectedValue ? [selectedValue] : []}
                onChange={(event, value) => {
                  onChange(value[value.length - 1])
                  closeDropdown()
                }}
              />
            </Container>
          )
        }}
      >
        {selectedValue ? (
          <ClassContainer>
            <ApostleIcon src={selectedClass?.icon} />
            <DisplayName>{selectedClass?.name}</DisplayName>
          </ClassContainer>
        ) : (
          <UnselectedText>
            {t('bounty.apostle.create_dialog.select_class')}
          </UnselectedText>
        )}
      </CustomDropdown>
    </>
  )
}

type Props = {
  selectedValue?: ApostleClassType
  onChange: (value: ApostleClassType) => void
}

export default ApostleClassSelector
